









































import { Component, Prop, Vue } from "vue-property-decorator";
import { OptProblemResult, OptProblemResults } from "@/mop_bindings";
import ObjsAvgChart from "@/components/ObjsAvgChart.vue";
import ResultCharts from "@/components/ResultCharts.vue";

enum ResultsModalType {
  Log,
  ObjsAvg,
  Result,
}

@Component
export default class Result extends Vue {
  @Prop()
  results: OptProblemResults | null = null;

  ResultsModalType = ResultsModalType;
  isResultsModalActivated = false;

  resultToString(result: OptProblemResult) {
    let str = "";
    const solution = result.solution().array();
    const objs = result.objs();
    const hcr = result.hard_cstrs();

    str += `Solution | x0: ${solution[0]}`;
    solution.slice(1).forEach((x: number, idx: number) => {
      str += `, x${idx + 1}: ${x}`;
    });
    str += "\n";

    str += `Objectives | AVG: ${result.objs_avg()}, f0: ${objs[0]}`;
    objs.slice(1).forEach((x: number, idx: number) => {
      str += `, f${idx + 1}: ${x}`;
    });
    str += "\n";

    if (hcr.length > 0) {
      str += `Hard constraints | g0: ${hcr[0]}`;
      hcr.slice(1).forEach((x: number, idx: number) => {
        str += `, g${idx + 1}: ${x}`;
      });
      str += "\n";
    }

    return str;
  }

  showLog(results: OptProblemResults) {
    let log = "";
    const best = results.best();
    if (best !== undefined) {
      log += "***** Best result *****\n";
      log += this.resultToString(best);
      log += "\n";
    }
    for (let idx = 0; idx < results.len(); idx++) {
      log += `***** Result ${idx + 1} *****\n`;
      log += this.resultToString(results.get(idx));
    }
    this.$buefy.modal.open("<pre>" + log + "</pre>");
  }

  showObjsAvgModal(results: OptProblemResults) {
    this.$buefy.modal.open({
      component: ObjsAvgChart,
      parent: this,
      props: { results },
    });
  }

  showResultModal(result: OptProblemResult) {
    this.$buefy.modal.open({
      component: ResultCharts,
      parent: this,
      props: { result },
    });
  }
}
